import {ComparatorBase, ComparisonTypeEnum} from "./ComparatorBase";

import * as React from "react";

export class CheckboxComparator extends ComparatorBase{

    public GetComparator(skipValueLessConditions=false){
        return (
            <select value={this.Condition.ConditionLineOptions.Comparison} onChange={x=>this.ComparisonChanged(x.target.value.toString())} style={{height:'auto',padding:0,marginLeft:5,width:'100%'}} >
                {!skipValueLessConditions&&<option value={ComparisonTypeEnum.IsChecked}>Is Checked</option>}
                {!skipValueLessConditions&&<option value={ComparisonTypeEnum.IsNotChecked}>Is Not Checked</option>}
            </select>
        );
    }

    public GetValueInput(){
        return null;
    }



    private ComparisonChanged(s: string) {
        this.Condition.ConditionLineOptions.Comparison=ComparisonTypeEnum[s];
        this.Condition.forceUpdate();
    }

    private ValueChanged(value: string) {
        this.Condition.ConditionLineOptions.Value=value;
        this.Condition.forceUpdate();
    }

    InitializeValues() {
        this.Condition.ConditionLineOptions.Comparison=ComparisonTypeEnum.IsChecked;
    }
}